
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { google } from 'google-maps';
import { useMissionsStore } from '../stores/missionsStore';
import RenderColors from '../services/colors';
import { GpsHelper } from '../services/GpsHelper';
import { RenderHelper } from '../services/RenderHelper';

@Component({ name: 'FlightpathPolyline' })
export default class FlightpathPolyline extends Vue {
  @Prop() googleApi!: google;
  @Prop() map!: google.maps.Map<HTMLDivElement>;
  @Prop() polyline!: google.maps.PolylineOptions;

  mapPolyLine = null as google.maps.Polyline | null;
  missionStore = useMissionsStore();
  startMarker: google.maps.Marker | null = null;
  endMarker: google.maps.Marker | null = null;

  destroyed() {
    this.mapPolyLine?.setMap(null);
    this.startMarker?.setMap(null);
    this.endMarker?.setMap(null);
  }

  mounted() {
    this.mapPolyLine = new this.googleApi.maps.Polyline({
      path: this.polyline.path,
      map: this.map,
      strokeColor: this.polyline.strokeColor,
      visible: this.polyline.visible,
      zIndex: this.polyline.zIndex
    });

    this.updatePathLengthAndMarkers();
  }

  @Watch('polyline')
  onLineChange() {
    if (this.mapPolyLine) {
      this.mapPolyLine.setPath(this.polyline.path as Array<google.maps.LatLng>);
      this.mapPolyLine.setVisible(true);
    }

    this.updatePathLengthAndMarkers();
  }

  updatePathLengthAndMarkers() {
    this.startMarker?.setMap(null);
    this.endMarker?.setMap(null);

    if (this.polyline.strokeColor == RenderColors.PlannedPath && this.mapPolyLine != null && this.mapPolyLine?.getPath().getLength() > 1) {
      const pathLengthMeters = Math.round(GpsHelper.findPathLengthInMeters(this.polyline.path as google.maps.LatLng[]));
      this.missionStore.setPathLengthKm(Math.round(pathLengthMeters / 100) / 10);

      this.startMarker = RenderHelper.createStartMakerWithLabel(this.mapPolyLine as google.maps.Polyline);
      this.startMarker.setMap(this.map);

      this.endMarker = RenderHelper.createStopMakerWithLabel(this.mapPolyLine as google.maps.Polyline);
      this.endMarker.setMap(this.map);
    }
  }
}
